import Header from "../../components/Header/Header";

import Agreement from "../../features/Search/components/Agree/Agreement";
import ProductView from "../../features/Search/components/Product/ProductView";

import DiscountList from "../../features/Search/components/Product/DiscountList";
import useProductDetail from "#features/Search/hooks/useProductDetail";

import { MdPriorityHigh } from "react-icons/md";
import erody from "../../assets/erody_wink_body.svg";
import Button from "../../components/Buttons/Button";
import { useNavigate } from "react-router-dom";
import useAgree from "#features/Search/hooks/agree/useAgree";
import { useState } from "react";
import useSelectBrand from "#hooks/styles/useSelectBrand";

const ProductDetailPage = () => {
  const { productDetail } = useProductDetail();
  const navigate = useNavigate();
  const { color } = useSelectBrand();
  const { onHandleAgree, agreement } = useAgree();

  const [modalIsOpen, setIsOpen] = useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <>
      {!agreement && <Agreement onHandleAgree={onHandleAgree} />}
      <section className="p-hasHeader">
        <Header title="상품 검색" />
        <ProductView productDetail={productDetail} openModal={openModal} />

        <div className={`mt-10 p-6 mb-6 rounded-[20px] border border-${color}`}>
          <div className="flex items-center gap-4 mb-6 border-b border-neutral-400">
            <span className="h-[72px] overflow-hidden">
              <img src={erody} alt="마스코트" />
            </span>
            <h2 className="relative flex items-center justify-center grow bg-neutral-600 rounded-[20px] text-white font-bold py-2.5 ">
              <MdPriorityHigh />
              상품 검색 주의사항
            </h2>
          </div>
          <ul className="flex flex-col gap-7">
            <li>
              <p className="mb-2 font-semibold">
                상품 정보 조회 매장 방문 시 주의사항
              </p>
              <ul className="text-sm font-medium text-neutral-500">
                <li className="flex gap-1 before:content-['•']">
                  <p>
                    점포별 영업 상황에 따라
                    <strong className="text-black"> 가격 및 재고 수량</strong>이
                    다소 차이가 날 수 있으니 양해 부탁드립니다.
                  </p>
                </li>
                <li className="flex gap-1 before:content-['•']">
                  <p>
                    전산 재고와
                    <strong className="text-black">
                      실재 재고 차이 보상은 지급되지 않습니다.
                    </strong>
                  </p>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <Button onClick={() => navigate(-1)}>검색목록으로</Button>
      </section>
      <DiscountList
        productDetail={productDetail}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
      />
    </>
  );
};

export default ProductDetailPage;
